import React from 'react';
import PropTypes from 'prop-types';
import {Image, Toaster} from '@learningblocks/storybook-components';
import {HeatblockContext} from '../../index';
import cogicon from '@learningblocks/exp-constants/lib/Images/CogIcon.svg';
import removeicon from '@learningblocks/exp-constants/lib/Images/removeicon.svg';

import style from './style.module.scss';

export function TubeTooltip(props) {
  const {heatblockWarnings} = React.useContext(HeatblockContext);

  const className = `${style.tubeTooltip} ${props.className}`;

  const openHeatblockModal = () => {
    props.toggleModal(!props.isModalOpen);
  };

  const removeTubesFromHeatblock = () => {
    heatblockWarnings(() => {
      props.removeTubeFromHeatblock();
    });
  };

  const renderCogalone = () => {
    return (
      <div className={style.tubeTooltip_cogalone} onClick={openHeatblockModal}>
        <Image src={cogicon} />
      </div>
    );
  };

  const renderBoth = () => {
    return (
      <div className={style.tubeTooltip_both}>
        <div
          className={style.tubeTooltip_both_remove}
          onClick={removeTubesFromHeatblock}>
          <Image src={removeicon} />
        </div>
        <div onClick={openHeatblockModal}>
          <Image src={cogicon} />
        </div>
      </div>
    );
  };

  const tubeTooltipDisplay = () => {
    if (props.tubeTooltip === true && props.filledSlots !== 0) {
      return renderBoth();
    } else if (props.tubeTooltip === true) {
      return renderCogalone();
    } else {
      return null;
    }
  };

  return <div className={className}>{tubeTooltipDisplay()}</div>;
}

TubeTooltip.propTypes = {};
